import React, { useEffect, useState } from 'react';
import SortableListItem from '@/components/ui/drag-and-drop/sortable-list-item/SortableListItem';
import { Icon, IconButton } from '@monash/portal-react';
import { deepClone } from '@monash/portal-frontend-common';
import { getShortcutIndex } from '../../utils';
import c from './edit-shortcut-mobile-row.module.scss';
import IconDisplay from '@/components/pages/custom/components/icon-display/IconDisplay';

export const EditShortcutMobileRow = ({
  shortcut,
  currentShortcut,
  isShortcutActive,
  setInEditShortcuts,
  validateShortcuts,
  setIsListDirty,
  onEdit,
}) => {
  const [, setIsNameValid] = useState(currentShortcut ? shortcut.name : null);
  const [, setIsUrlValid] = useState(currentShortcut ? shortcut.url : null);

  const deleteInEditShortcut = () => {
    setIsListDirty(true);
    setInEditShortcuts((f) => {
      const newShortcuts = deepClone(f);
      const inEditShortcutIndex = getShortcutIndex(shortcut.id, newShortcuts);
      newShortcuts.splice(inEditShortcutIndex, 1);
      validateShortcuts(newShortcuts);
      return newShortcuts;
    });
  };

  // Validate shortcut when shortcut is active (in drag and drop action), so the validation statuses of both drag overlay and draggable items are consistent
  useEffect(() => {
    if (isShortcutActive) {
      setIsNameValid(shortcut.name);
      setIsUrlValid(shortcut.url);
    }
  }, [isShortcutActive]);

  return (
    <SortableListItem
      id={shortcut.id}
      className={c.editableShortcutContainer}
      itemLabel={shortcut.name}
    >
      <span>
        <IconDisplay icon={shortcut.icon} url={shortcut.url} />
      </span>

      <div className={c.name}>{shortcut.name}</div>

      <div className={c.buttons}>
        <IconButton
          onClick={() => onEdit(shortcut.id)}
          variant="text"
          mode="card"
          icon={Icon.Pencil}
          color="var(--card-text-color)"
          size={24}
          aria-label="Edit shortcut"
        />
        <IconButton
          onClick={deleteInEditShortcut}
          variant="text"
          mode="card"
          icon={Icon.Trash}
          color="var(--color-intent-attention)"
          size={24}
          aria-label="Delete shortcut"
        />
      </div>
    </SortableListItem>
  );
};
